import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Projects from '../../api/project';
import OptimizedImage from '../OptimizedImage';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import arabicBg from '../../images/arabic-bg-dark.svg';
import anasBotImg from '../../images/children/anas_bot.png';
import boyAndGirlImg from '../../images/children/boy_and_girl.png';
import './style.css';
import { withTranslation } from 'react-i18next';

class ProjectSection extends Component {
    render() {
        const { t, i18n } = this.props; // Translation function
        const isRtl = i18n.language === 'ar';

        // Custom arrow components
        const NextArrow = (props) => {
            const { onClick } = props;
            return (
                <button className={`slick-arrow slick-next ${isRtl ? 'rtl-flip' : ''}`} onClick={onClick} aria-label="Next video">
                    {isRtl ? <FaChevronRight /> : <FaChevronRight />}
                </button>
            );
        };

        const PrevArrow = (props) => {
            const { onClick } = props;
            return (
                <button className={`slick-arrow slick-prev ${isRtl ? 'rtl-flip' : ''}`} onClick={onClick} aria-label="Previous video">
                    {isRtl ? <FaChevronLeft /> : <FaChevronLeft />}
                </button>
            );
        };

        var settings = {
            dots: false,
            arrows: true,
            rtl: isRtl,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />,
            speed: 1000,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };


        return (
            <section
                className="wpo-project-section section-padding"
                style={{
                    position: 'relative'
                }}
            >
                {/* Arabic Background */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: `url(${arabicBg})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        opacity: 0.05,
                        zIndex: 0
                    }}
                />
                <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-12">
                            <div className="section-title text-left">
                                <span>{t('projectSection.videos')}</span>
                                <h2>{t('projectSection.exploreVideoContent')}</h2>
                                <div className="transparent-text">{t('projectSection.videosTransparent')}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                    <div className="project-active owl-carousel">
                        <Slider {...settings}>
                            {Projects.map((project, prj) => (
                                <div className="wpo-project-item" key={prj}>
                                    <div className="wpo-project-text">
                                        <h2><a href={`https://www.youtube.com/watch?v=${project.videoId}`} target="_blank" rel="noreferrer">{project.cTitle}</a></h2>
                                    </div>
                                    <div className="wpo-project-img">
                                        <a href={`https://www.youtube.com/watch?v=${project.videoId}`} target="_blank" rel="noreferrer">
                                            <OptimizedImage
                                                src={project.pImg}
                                                alt={project.cTitle}
                                                loading="lazy"
                                                decoding="async"
                                                width={400}
                                                height={300}
                                            />
                                        </a>
                                    </div>
                                    <div className="wpo-project-thumb">
                                        <span>{project.Id}</span>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                    <div className="section-title-s4">
                        <div className="transparent-text"></div>
                    </div>
                </div>

                {/* Anas Bot image positioned at left bottom corner */}
                <div className="project-anas-bot-container">
                    <img src={anasBotImg} alt="Anas Bot" className="project-anas-bot-img" loading="lazy" decoding="async" />
                </div>

                {/* Boy and girl image positioned at right bottom corner */}
                <div className="project-boy-girl-container">
                    <img src={boyAndGirlImg} alt="Boy and girl" className="project-boy-girl-img" loading="lazy" decoding="async" />
                </div>
            </section>
        );
    }
}

export default withTranslation()(ProjectSection);